import { createAction } from './action-utils';

export const ADD_EXPECTATION_MANAGEMENT_CASE =
  'ADD_EXPECTATION_MANAGEMENT_CASE';

const actions = {
  addCase: (caseGuid: string) =>
    createAction<string, { caseGuid: string }>(
      ADD_EXPECTATION_MANAGEMENT_CASE,
      { caseGuid },
    ),
};

export default actions;
